import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import SVG from 'react-inlinesvg';
import sendIcon from '@lifesize/ux-assets/vectors/svgIcons/send.svg';
import classes from './ChatMessageInput.module.scss';

const messages = defineMessages({
  messageInput: { id: 'components.chat.message', defaultMessage: 'Type your message here' },
  messageReadOnly: { id: 'components.chat.readOnly', defaultMessage: 'This conversation is read-only. The recipient(s) do not have a Lifesize account and cannot receive messages now that the call has ended.' },
});

class ChatMessageInput extends Component {
  componentDidMount() {
    this.drawer = document.getElementById('inCallDrawer');
    this.focusChatInput();
  }

  componentDidUpdate(prevProps) {
    const prevConv = prevProps.conversation || {};
    const newConv = this.props.conversation || {};

    // focus on the input when the conversation changes
    if (prevConv.conversationId !== newConv.conversationId) {
      this.focusChatInput();
    }
  }

  onMessageKeyPress(event) {
    if (event.which === 13 && !event.shiftKey) {
      event.preventDefault();
      if (!this.isSendDisabled()) {
        this.props.onMessageSend(this.getFieldName(), this.props.formValues);
      }
    }
  }

  getFieldName() {
    return this.props.conversation && this.props.conversation.conversationId ?
      'chatMessage'.concat(this.props.conversation.conversationId.replace(/\./g, '')) :
      'chatMessage';
  }

  focusChatInput() {
    if (!this.isInputDisabled()) {
      if (this.drawer) {
        setTimeout(() => {
          if (this.inputField) {
            this.inputField.getRenderedComponent().focus();
          }
        }, 500);
      } else if (this.inputField) {
        this.inputField.getRenderedComponent().focus();
      }
    }
  }

  isInputDisabled() {
    return !this.props.conversation;
  }

  isSendDisabled() {
    const message = this.props.formValues[this.getFieldName()];
    return !message || !message.trim() || this.isInputDisabled();
  }

  render() {
    const { hasOnlyGuests, intl, onMessageSend } = this.props;

    if (hasOnlyGuests) {
      return (
        <div
          className={`${classes.messageContainer} ${classes.alert}`}
          id="chatMessageForm"
        >
          {intl.formatMessage(messages.messageReadOnly)}
        </div>
      );
    }

    return (
      <form
        name="chat"
        className={classes.messageContainer}
        id="chatMessageForm"
        onSubmit={(event) => {
          event.preventDefault();
          onMessageSend(this.getFieldName(), this.props.formValues);
        }}
      >
        <Field
          name={this.getFieldName()}
          component="textarea"
          type="textarea"
          id="chatMessageField"
          className={classes.messageInput}
          onKeyPress={event => this.onMessageKeyPress(event)}
          placeholder={intl.formatMessage(messages.messageInput)}
          disabled={this.isInputDisabled()}
          rows={2}
          ref={(input) => { this.inputField = input; }}
          forwardRef
          autoFocus
        />
        {this.props.pristine ? null :
          <button
            className={classes.messageSendButton}
            type="submit"
            id="chatSendMessageButton"
            disabled={this.isSendDisabled()}
            onClick={(event) => {
              event.preventDefault();
              onMessageSend(this.getFieldName(), this.props.formValues);
            }}
          >
            <SVG src={sendIcon} />
          </button>}
      </form>
    );
  }
}

ChatMessageInput.propTypes = {
  conversation: PT.object, // provided by Parent Component
  formValues: PT.object,
  hasOnlyGuests: PT.bool,
  intl: PT.object,
  onMessageSend: PT.func,
  pristine: PT.bool,
  chatContact: PT.object,
};

export default reduxForm({
  form: 'chat',
  destroyOnUnmount: false,
  getFormState: state => state.app.form
})(injectIntl(ChatMessageInput));
